<template>
  <div>
    <div class="text-center">
      <div class="side-by-side">
        <IconPicker v-model="costCenter.icon" :color="costCenter.color" />
      </div>
      <div class="side-by-side cost-center-create-update-color">
        <ColorPicker v-model="costCenter.color" />
      </div>
    </div>
    <b-row>
      <b-col sm="12">
        <InputText title="Nome" field="name" :formName="formName" :required="true" :maxLength="40"
          v-model="costCenter.name" :markFormDirty="false" />
      </b-col>

    </b-row>
    <b-row>
      <b-col sm="6">
        <RadioGroup title="Tipo" field="type" :formName="formName" :options="[
          { text: 'Receita', value: 1 },
          { text: 'Despesa', value: 2 },
        ]" v-model="costCenter.type" />
      </b-col>
    </b-row>
    <b-row>
      <b-col sm="12">
        <div class="text-right">
          <Button _key="btnSaveCostCenter" type="success" title="Salvar" :disabled="!isFormValid(formName)"
            classIcon="fas fa-save" size="medium" :clicked="saveCostCenter" />
        </div>
      </b-col>
    </b-row>
  </div>
</template>

<script>
import Button from "@/ui/forms/Button";
import ColorPicker from "@/ui/layout/ColorPicker";
import IconPicker from "@/ui/layout/IconPicker";
import InputText from "@/ui/forms/InputText";
import RadioGroup from "@/ui/forms/RadioGroup.vue";

import CostCenter from "../../models/CostCenter";
import CostCenterService from "../../services/costCenter.service";

import { mapGetters, mapMutations } from "vuex";

export default {
  name: "CostCenterCreateUpdate",
  props: {
    registerInSelect: Boolean,
    value: Object,
  },
  components: { Button, ColorPicker, IconPicker, InputText, RadioGroup },
  data() {
    return {
      formName: "costCenterCreateUpdate",
      costCenter: new CostCenter(),
    };
  },
  computed: {
    ...mapGetters("validation", ["isFormValid"]),
    ...mapGetters("generic", ["event"]),
  },
  methods: {
    ...mapMutations("generic", [
      "addEvent",
      "removeLoading",
      "removeEvent",
      "hideModal",
      "hideVodal",
    ]),
    ...mapMutations("validation", ["resetValidation"]),
    async saveCostCenter() {
      try {
        if (this.costCenter.id) {
          const response = await CostCenterService.update(this.costCenter);
          if (response.success) {
            this.addEvent({ name: "costCenterSaved" });
            if (!this.registerInSelect) this.hideModal();
          }
          return;
        }

        const response = await CostCenterService.create(this.costCenter);
        if (response.success) {
          this.addEvent({ name: "costCenterSaved" });
          if (!this.registerInSelect) this.hideModal();
          if (this.registerInSelect) {
            this.$emit("input", {
              id: response.content.id,
              content: response.content.name,
            });
            this.hideVodal(this.formName);
          }
        }
      } finally {
        this.removeLoading(["btnSaveCostCenter"]);
      }
    },
    update(data) {
      this.costCenter = new CostCenter();
      this.costCenter.update(data);
      this.removeLoading([data.id]);
    },
  },
  watch: {
    event: {
      handler(event) {
        if (event.name == "costCenterCreate") {
          this.resetValidation(this.formName);
          this.costCenter = new CostCenter();
        }
        if (event.name == "costCenterUpdate") this.update(event.data);
      },
      deep: true,
    },
  },
};
</script>
<style scoped>
.cost-center-create-update-color {
  padding: 5px;
}
</style>
